import {
  Button,
  CodeBlock,
  CopyIcon,
  Dialog,
  Link,
  Stack,
  Typography,
  ValidateIcon,
} from '@all-manager/design-system-v2';
import { useGoogleScriptModal } from './useGoogleScriptModal';

type Props = {
  open: boolean;
  onClose: () => void;
  spaceSlug?: string;
  spaceId?: string;
};

const BLOCK_TEXT = { body2: 'div' };
const SECTION_HEADING = { subtitle1: 'h3' };
const SUBSECTION_HEADING = { subtitle2: 'h4' };

export default function GoogleScriptModal(props: Props) {
  const { scriptCode, copied, handleCopy } = useGoogleScriptModal(props);

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth="md"
      fullWidth
      title="Configuration de la boîte de réception"
      closeLabel="Fermer"
      actions={{ primaryAction: { label: 'Fermer', onClick: props.onClose } }}
    >
      <Stack spacing={3}>
        <Stack spacing={1}>
          <Typography variant="subtitle1" variantMapping={SECTION_HEADING}>
            Synchronisation automatique Gmail
          </Typography>
          <Typography variant="body2">
            Connectez votre boîte Gmail gratuitement grâce à Google Apps Script. Vos nouveaux emails et leurs pièces jointes seront transmis automatiquement à l&apos;application sans nécessiter de serveur payant.
          </Typography>
        </Stack>

        <Stack spacing={1}>
          <Typography variant="subtitle2" variantMapping={SUBSECTION_HEADING}>
            Étapes d&apos;installation (2 minutes)
          </Typography>
          <Typography variant="body2" variantMapping={BLOCK_TEXT}>
            <ol>
              <li>
                Rendez-vous sur{' '}
                <Link href="https://script.google.com" target="_blank" rel="noreferrer">
                  script.google.com
                </Link>{' '}
                avec votre compte Google et cliquez sur <strong>« Nouveau projet »</strong>.
              </li>
              <li>
                Remplacez tout le contenu par le script ci-dessous, puis cliquez sur <strong>Enregistrer</strong>.
              </li>
              <li>
                Cliquez sur l&apos;icône de réveil (<strong>Déclencheurs</strong>) à gauche :
                <ul>
                  <li>Ajouter un déclencheur → Fonction : <code>syncGmailToCopro</code></li>
                  <li>Source de l&apos;événement : <code>Selon le temps</code></li>
                  <li>Type de déclencheur temporel : <code>Toutes les 5 minutes</code></li>
                </ul>
              </li>
              <li>
                <em>Astuce :</em> Vous pouvez attribuer le libellé <code>copro</code> dans Gmail aux messages que vous souhaitez importer automatiquement.
              </li>
            </ol>
          </Typography>
        </Stack>

        <CodeBlock
          label="Script prêt à l'emploi"
          code={scriptCode}
          action={(
            <Button
              variant="text"
              color="default"
              size="small"
              startIcon={copied ? <ValidateIcon /> : <CopyIcon />}
              onClick={handleCopy}
            >
              {copied ? 'Copié !' : 'Copier le script'}
            </Button>
          )}
        />
      </Stack>
    </Dialog>
  );
}
